<template>
  <summary-section
    v-if="userDisorders.length > 0 && showDisorderList || userIsOnTheirOwnProfile"
    heading="Health Profile"
    data-test-id="profile-health-profile-summary-section"
  >
    <template v-slot:actions>
      <router-link
        v-if="link"
        :to="link"
        class="summary-section__action-link"
        data-test-id="profile-health-profile-summary-section-link"
      >
        Edit
      </router-link>
    </template>
    <template class="health-profile-summary">
      <loading-spinner v-if="loading !== 0" />
      <user-disorder-list
        v-if="userDisorders.length"
        :user-disorders="userDisorders"
        :show-badges="true"
      />
      <p
        v-else
        class="health-profile-summary__placeholder"
      >
        You have not filled in your health profile yet.
      </p>
    </template>
  </summary-section>
</template>

<script>
import SummarySection from '@/components/User/Summary/SummarySection.vue';
import UserDisorderList from '@/components/User/UserDisorderList.vue';
import { mapGetters } from 'vuex';
import { USER_DISORDERS, USER_PRIVACY_SETTINGS_QUERY } from '@/graphql/queries/user-queries';

export default {
  components: {
    SummarySection,
    UserDisorderList,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: 0,
      userDisorders: [],
      disordersArePrivate: true,
    };
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    userIsOnTheirOwnProfile() {
      return this.user.id === this.currentUser.id;
    },
    showDisorderList() {
      return this.userIsOnTheirOwnProfile || !this.disordersArePrivate;
    },
  },
  apollo: {
    userDisorders: {
      query: USER_DISORDERS,
      variables() {
        return {
          userId: this.user.id.toString(),
        };
      },
    },
    userPrivacySettings: {
      query: USER_PRIVACY_SETTINGS_QUERY,
      variables() {
        return {
          userId: this.user.id.toString(),
          name: 'user_disorders',
        };
      },
      result({ data }) {
        const [disorderPrivacySetting] = data.userPrivacySettings;
        if (disorderPrivacySetting !== undefined) {
          this.disordersArePrivate = disorderPrivacySetting.isPrivate;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_health-profile-summary';
</style>
